import { Outlet, useFetcher } from "@remix-run/react";
import { ProjectsLoader } from "~/routes/api.projects/route";
import React, { useEffect, useState } from "react";
import { Project, TimeLog } from "~/lib";
import { TimeLogsLoader } from "~/routes/api.time-logs/route";
import { DateTime, Interval } from "luxon";

export default function TimeLogs() {
  const projectFetcher = useFetcher<ProjectsLoader>();
  const timeLogFetcher = useFetcher<TimeLogsLoader>();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [projects, setProjects] = useState<Project[]>([]);
  const [timeLogs, setTimeLogs] = useState<TimeLog[]>([]);

  const loadData = () => {
    if (projectFetcher.state !== "idle" || timeLogFetcher.state !== "idle") {
      return;
    }

    const dummyCutoff = DateTime.now().toUnixInteger();

    projectFetcher.load(`/api/projects?since=${dummyCutoff}`);
    timeLogFetcher.load(`/api/time-logs`);
  };

  useEffect(() => {
    loadData();
  }, []);

  // Set data from load
  useEffect(() => {
    if (projectFetcher.data && timeLogFetcher.data) {
      setProjects(projectFetcher.data.projects);
      const timeLogs = timeLogFetcher.data.timeLogs;
      timeLogs.sort((a, b) => b.startTime - a.startTime);
      setTimeLogs(timeLogFetcher.data.timeLogs);
      setIsLoading(false);
    }
  }, [projectFetcher.data, timeLogFetcher.data]);

  const projectsById = new Map(
    projects.map((project) => [project.id, project]),
  );

  const timeLogTable = timeLogs.map((timeLog) => {
    const interval = Interval.fromDateTimes(
      DateTime.fromSeconds(timeLog.startTime),
      DateTime.fromSeconds(timeLog.stopTime),
    );

    return (
      <div key={timeLog.id}>
        <p>{projectsById.get(timeLog.projectId)?.name ?? "Unknown Project"}</p>
        <p>{interval.toDuration().toFormat("hh:mm:ss")}</p>
        <p>{interval.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}</p>
        <a href={`/time-logs/${timeLog.id}`}>Edit</a>
      </div>
    );
  });

  return (
    <div>
      <Outlet />
      <h1>Time Logs</h1>
      {isLoading ? <p>Loading...</p> : timeLogTable}
    </div>
  );
}
